import { render, staticRenderFns } from "./ProcessReport2.vue?vue&type=template&id=a90beaf2&scoped=true"
import script from "./ProcessReport2.vue?vue&type=script&lang=js"
export * from "./ProcessReport2.vue?vue&type=script&lang=js"
import style0 from "./ProcessReport2.vue?vue&type=style&index=0&id=a90beaf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90beaf2",
  null
  
)

export default component.exports